import { render, staticRenderFns } from "./SumupDetailCurriculum.vue?vue&type=template&id=57e52902&scoped=true&"
import script from "./SumupDetailCurriculum.vue?vue&type=script&lang=ts&"
export * from "./SumupDetailCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./SumupDetailCurriculum.vue?vue&type=style&index=0&id=57e52902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e52902",
  null
  
)

export default component.exports